module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"order":"訂單內容","logistic_fee":"物流費用","total":"總計","logistic":"物流配送"},"en":{"order":"Order","logistic_fee":"Delivery Fee","total":"Total","logistic":"Delivery"}}')
  delete Component.options._Ctor
}
